import { AxiosInstance } from 'axios'
import { BeforeAfterItem, Localizations, MediaObject } from '../types'
import { BlocksContent } from '@strapi/blocks-react-renderer'

export interface ServiceCategoryDetailsDto {
  id: number
  attributes: ServiceCategory
}

export interface ServiceCategory {
  localizations: Localizations
  name: string
  slug: string
  image?: MediaObject
  short_description?: string
  description?: string
  order: number
  show_in_footer: boolean
  show_all_promo: boolean
  services?: { data: ServiceItem[] }
  child_categories?: {
    data: { attributes: { name: string; slug: string }; id: number }[]
  }
  before_after_text?: BlocksContent
  before_afters?: {
    data: BeforeAfterItem[]
  }
}

export interface ServiceItem {
  id: number
  attributes: {
    name: string
    slug: string
  }
}

export type GetServiceCategoryDetailsArgs = {
  locale: string
  slug: string
}

export const getServiceCategoryDetails = async (
  client: AxiosInstance,
  { locale, slug }: GetServiceCategoryDetailsArgs,
) => {
  const path = `/service-categories`
  const params = {
    locale,
    fields: [
      'name',
      'slug',
      'short_description',
      'description',
      'order',
      'show_in_footer',
      'show_all_promo',
      'before_after_text',
    ],
    populate: {
      localizations: {
        fields: ['locale', 'slug'],
      },
      image: { fields: ['*'] },
      child_categories: {
        fields: ['name', 'slug'],
      },
      services: {
        fields: ['name', 'slug'],
      },
      before_afters: {
        populate: {
          before: '*',
          after: '*',
        },
      },
    },
    filters: {
      slug: {
        $eq: slug,
      },
    },
  }
  return (await client.get<{ data: Array<ServiceCategoryDetailsDto> }>(path, { params })).data.data[0]
}
